import { AlertTriangle } from "lucide-react";

/** Shown on phone only — gallery picks are often full-res and can exceed the API limit. */
export default function MobileUploadSizeHint({ className = "" }) {
  return (
    <p className={`sm:hidden text-xs text-[var(--zc-warn)] flex items-start gap-1.5 ${className}`}>
      <AlertTriangle size={12} className="shrink-0 mt-0.5" />
      Only images 5 MB or smaller can be uploaded. Larger files will be rejected.
    </p>
  );
}
